// extracted by mini-css-extract-plugin
export default {"socialMedia":"SocialMedia_socialMedia__IYc21"};